import React, {  } from 'react';
import { withStyles, StyledComponentProps, Grid, Typography } from '@material-ui/core';
import { withRouter } from 'react-router';
import { actionCreator as userStatsActions, IActions as IUserStatsActions } from '../common/store/userstats/actions/creators';
import { IState as IUserStatsState } from '../common/store/userstats/state';
import { IApplicationState } from '../store/ApplicationState';
import { connect } from 'react-redux';
import { layoutStyle } from './Layout.style';
import { IMediaQueryProps, WithMediaQuery } from './withMediaQuery';
import { IRouterAppProps } from '../common/interfaces/IRouterAppProps';
import { Alert } from '@material-ui/lab';

interface IOuterProps {
}
interface IProps extends StyledComponentProps, IRouterAppProps, IUserStatsActions, IUserStatsState, IMediaQueryProps {
}

class UserStatsComponentClass extends React.Component<IProps & IOuterProps> {

    idIntervall;

    componentDidMount = () => {
        this.props.getStats();
        //richamo ogni 5 minuti
        this.idIntervall = setInterval(() => this.props.getStats(), 1000 * 60 * 5);
    }


    render() {
        return (<div>{this.props.smallScreen ?
             <span></span> :
            this.props.errorFetchUserStats ?
                <Alert severity="error">
                    Errore nel caricare le statistiche
            </Alert> :
                (this.props.stats ?
                    <Grid item className={this.props.classes.userStatsContainer}>
                        <div className={this.props.classes.userStatContainer}>
                            <Typography>Ingressi</Typography>
                        </div>
                        <div className={this.props.classes.userStatContainer}>
                            <span className={this.props.classes.userStatNumer}>{this.props.stats.accesses}</span>
                            <Typography>Utenti</Typography>
                        </div>
                        <div className={this.props.classes.userStatContainer}>
                            <span className={this.props.classes.userStatNumer}>{this.props.stats.users}</span>
                            <Typography>Attivi</Typography>
                        </div>
                        <div className={this.props.classes.userStatContainer}>
                            <span className={this.props.classes.userStatNumer}>{this.props.stats.signUp}</span>
                            <Typography>Nuovi</Typography>
                        </div>
                        <div className={this.props.classes.userStatContainer}>
                            <span className={this.props.classes.userStatNumer}>
                                {this.props.stats.bookedSlots}/{this.props.stats.reservationSlots}</span>
                            <Typography>Prenotazioni Totali (Oggi)</Typography>
                        </div>
                    </Grid > :
                    <></>)
        }
        </div>)
    }

    componentWillUnmount() {
        if (this.idIntervall) {
            clearInterval(this.idIntervall);
        }
    }

}

const mapStateToProps = (state: IApplicationState, ownp: any) => ({ ...ownp, ...state.userstats });
const mapDispatchToProps = d => ({ ...userStatsActions(d) });

export const UserStatsComponent = withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(layoutStyle)(WithMediaQuery(UserStatsComponentClass))));